<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela :items="items" :loading="loading" @rechargeTable="getAll()" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import AgingService from '@/services/AgingService';
  import pusherMixins from '@/mixins/pusherMixins';
  import tourMixins from '@/mixins/tourMixins';
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';
  import dayjs from 'dayjs';

  export default {
    components: {
      Tabela: () => import('@/components/aging/Tabela.vue')
    },
    mixins: [pusherMixins, tourMixins, dateFormatterMixins],

    data: () => ({
      items: [],
      loading: false,
      arrTour: [
        {
          element: '#btn-novo-aging',
          intro: 'Clicando neste botão você poderá criar novas análises.',
          scrollTo: 'tooltip',
          position: 'right'
        },
        {
          element: '#aging-historico-search',
          intro: 'Neste campo você poderá pesquisar por registros já existentes.',
          scrollTo: 'tooltip',
          position: 'bottom'
        },
        {
          element: '#action-download-aging',
          intro: 'Clicando neste ícone você poderá fazer o download em .XLSX do resultado da sua análise.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-edit-aging',
          intro: 'Clicando neste ícone você poderá editar sua análise.',
          scrollTo: 'tooltip',
          position: 'left'
        },
        {
          element: '#action-more-aging',
          intro: 'Aqui você acessa outras opções, como ver mais detalhes, executá-la novamente, duplicá-la ou deletá-la.',
          scrollTo: 'tooltip',
          position: 'left'
        }
      ]
    }),

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refreshAgings', () => {
          this.getAll();
        });
      },

      getAll() {
        this.loading = true;

        AgingService.getAll()
          .then(({ data }) => {
            const records = Array.isArray(data?.data) ? data.data : [];

            this.items = records.map((item) => ({
              id: item.id,
              titulo: item.titulo,
              data_base: this.formatDateValue(item.data_base),
              data_projetada: this.formatDateValue(item.data_projetada),
              tipo_base: item.tipo_base,
              tucs_label: this.formatTucsLabel(item.tucs),
              status: item.status,
              usuario: item.usuario?.nome || '-',
              created: item.created,
              data_processamento: item.data_processamento ? dayjs(item.data_processamento).format('DD/MM/YYYY HH:mm') : '-'
            }));
          })
          .catch((error) => {
            console.error('Erro ao recuperar os registros de Aging:', error);
            this.$toast.error('Erro ao recuperar os registros de Aging.', '', { position: 'topRight' });
          })
          .finally(() => {
            this.loading = false;
            this.iniciarTourPagina();
          });
      },

      formatDateValue(value) {
        if (!value) {
          return '-';
        }

        const rawValue = typeof value === 'object' && value.date ? value.date : String(value);
        const date = rawValue.includes('T') ? rawValue.split('T')[0] : rawValue;

        return dayjs(date).isValid() ? dayjs(date).format('DD/MM/YYYY') : '-';
      },

      formatTucsLabel(tucs) {
        if (tucs == null || tucs === '') {
          return '-';
        }

        if (Array.isArray(tucs)) {
          return tucs.join(', ');
        }

        return String(tucs);
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;

        const arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.slice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>
